/**
 * Resolve possibly-relative image URLs to absolute, prefixing /api/ uploads with backend URL.
 */
const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export const resolveImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
  if (url.startsWith('/api/')) return `${BACKEND}${url}`;
  if (url.startsWith('/')) return `${BACKEND}${url}`;
  return url;
};
